import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import {
    AppBar,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    Stack,
    TextField,
    Toolbar,
    Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AgGridTable from "../utilities/AgGridTable";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";

const ViewFinanceInvoiceData = (props) => {
    const [FIDialog, setFIDialog] = useState(false)

    const openDialog = ()=>{
        setFIDialog(true);
    }
    const onClose = () =>{
        setFIDialog(false);
    }
    
    return (
        <>
            <IconButton size="small" onClick={openDialog} sx={{p:0}}>
                <FuseSvgIcon>heroicons-solid:eye</FuseSvgIcon>
            </IconButton>

            <Dialog
                open={FIDialog}
                onClose={onClose}
                fullWidth={true}
                maxWidth={"md"}
                
            >
        <DialogTitle color="inherit">
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Finance Invoice</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={onClose}>
                <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
              </Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent sx={{height: "500px"}} dividers>
          <DialogContentText id="alert-dialog-description">
            <>
              
            </>
          </DialogContentText>
        </DialogContent>
      </Dialog>
        </>
    );
};
export default ViewFinanceInvoiceData;
